import { Space as AntSpace } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import { JiraConfig, SettingsMeta } from 'api/integrations/jira';
import { Form } from 'components/atoms/form';
import { Switch } from 'components/atoms/switch/switch';
import { MiniTable } from 'components/molecules/table';
import { useTranslation } from 'hooks/use-translation';
import { FormItem, SubText, Title } from '../styles';
import { SectionKeys } from '../types';
import { columns } from './columns';

const statusFieldData = [
  {
    jiraField: 'To do',
    rlField: 'To do',
  },
  {
    jiraField: 'In Progress',
    rlField: 'In Progress',
  },
  {
    jiraField: 'Done',
    rlField: 'Completed',
  },
];

const Space = styled(AntSpace)`
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 16px;
  width: 100%;
`;

interface FieldSync {
  jiraConfig: JiraConfig;
  onChange: (updatedObject: SettingsMeta, key?: SectionKeys) => void;
  updating?: SectionKeys;
}

export const StatusFieldSync: FC<FieldSync> = ({
  jiraConfig,
  updating,
  onChange,
}) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const title = useTranslation('settings.integrations.jira.fields_sync.title');
  const help = useTranslation('settings.integrations.jira.fields_sync.help');

  const [form] = Form.useForm();

  useEffect(() => {
    if (updating) {
      if (updating === SectionKeys.STATUS_SYNC) {
        setLoading(true);
      } else {
        setDisabled(true);
      }
    } else {
      setLoading(false);
      setDisabled(false);
    }
  }, [updating, setLoading, setDisabled]);

  return (
    <>
      {/* Head switch and content */}
      <Space>
        <Form
          form={form}
          onValuesChange={(syncTaskStatusField) =>
            onChange(
              { ...jiraConfig.settingsMeta, ...syncTaskStatusField },
              SectionKeys.STATUS_SYNC,
            )
          }
          initialValues={jiraConfig.settingsMeta}
        >
          <FormItem name="syncTaskStatusField" valuePropName="checked">
            <Switch size="small" loading={loading} disabled={disabled} />
          </FormItem>
        </Form>
        <Title noMargin>{title}:</Title>
        <SubText noMargin>{help}</SubText>
      </Space>

      <MiniTable
        columns={columns}
        dataSource={statusFieldData}
        pagination={false}
        size="small"
      />
    </>
  );
};
